import { isString } from 'ionic-angular/util/util';
import { Observable } from 'rxjs/Observable';
import { ActionOptionsArgs } from '../../../core/store/actions/base-actions';
import { isInArray } from '../../../core/util/is-in-array';
import { AccountObjectStoreFacade } from '../account-object/account-object.store-facade';
import { Control } from '../control/control.model';
import { Job } from '../job/job.model';
import * as actions from './field.actions';
import { Field } from './field.model';

export class FieldStoreFacade extends AccountObjectStoreFacade<Field> {

    getAll(): Observable<Array<Field>> {
        return this.appFacade.objects.job.store.getAllInlined()
            .map(jobs => {
                return jobs.reduce((p, v) => {
                    return p.concat(v.fields);
                }, []);
            });
    }

    /**
     *
     * @param field
     * @deprecated fields are inlined into jobs
     */
    create(field: Field): void {
        // noop
    }

    /**
     *
     * @param field
     * @deprecated fields are inlined into jobs
     */
    update(field: Field): void {
        // noop
    }

    /**
     *
     * @param field
     * @deprecated fields are inlined into jobs
     */
    insert(field: Field): void {
        // noop
    }

    /**
     *
     * @param field
     * @param options
     * @deprecated fields are inlined into jobs
     */
    remove(field: Field, options?: ActionOptionsArgs): void {
        // noop
    }

    bumpVersion(jobId: string, fieldId: string): void {
        this.dispatch(new actions.BumpVersionAction({jobId, fieldId}));
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/field/field.store-facade.ts